import { useMutation } from 'react-query';
import { api } from 'services/api';

type UseConfirmEmail = {
  /**
   * Session hash generated by backend.
   */
  session: string;
  /**
   * User e-mail.
   */
  email: string;
};

export type ConfirmEmailResponse = {
  session: string;
  event: string;
  email: string;
};

type GetUnitsProps = {
  status: number;
  data: ConfirmEmailResponse;
};

export const confirmEmail = async (
  params: UseConfirmEmail
): Promise<GetUnitsProps> => {
  const { status, data } = await api.post('/auth/v2/email-confirm', {
    session: params.session,
    email: params.email,
  });

  return {
    status,
    data: data.data,
  };
};

export const useConfirmEmail = () => {
  return useMutation('email-confirm', (params: UseConfirmEmail) =>
    confirmEmail(params)
  );
};
